module.exports = {
    data: {
        terminal: '智能终端',
        smartCar: '智能巡检车',
        smartChip: '智能模组'
    },
    // 智能测温仪
    thermometer: {
        title: "智能测温仪",
        introduction: "智能测温仪除具备实时监测人体温度和异常报警外，支持人脸识别和身份验证（可选），适应于多种场景。",
        message1: {
            title: "双摄像头",
            message1: "智能测温与人脸识别",
            message2: "实时语音预警，记录图像与视频片段",
        },
        message2: {
            title: "身份核验",
            message1: "通过人脸识别进行身份验证",
        },
        message3: {
            title: "云平台服务",
            message1: "监控数据实时上传至云端服务器",
            message2: "统一后台管理与数据监控",
        },
        message4: {
            title: "体温检测",
            message1: "获取人脸额头温度，实时显示",
            message2: "摄像头可见范围内均可检测",
        }
    },
    // 智能门禁
    accessControl: {
        title: '智能门禁',
        introduction: '智能门禁是一款基于原创人脸识别技术的安防终端设备。产品内部搭载全线通高性能AI模组，能快速准确进行本地身份识别。\n',
        subtitle1: {
            title: '双目活检',
            intro1: '实时捕捉人脸，流畅无延迟',
            intro2: '视角宽广，支持多人识别',
        },
        subtitle2: {
            title: '多场景识别',
            intro1: '全光照环境识别无障碍',
            intro2: '人脸追踪曝光专利算法'
        },
        subtitle3: {
            title: '智能考勤',
            intro1: '智能考勤报表',
            intro2: '刷脸开门即考勤',
        },
        subtitle4: {
            title: '单机与联网模式',
            intro1: '单机模式可独立本地学习和训练',
            intro2: '联网模式支持数据加密和云端同步',
        },
    },
    //汽车辅助驾驶
    ADAS: {
        title: '汽车辅助驾驶',
        introduction: '车内外场景无缝衔接、实时智能分析。车外紧急情况预警、交通标志识别、目标识别、车内驾驶员的行为分析、头姿检测。',
        subtitle1: {
            title: '单向与双向摄像头',
            intro1: '单摄像头模式在线实时分析车外各种场景和紧急情况预警',
            intro2: '双摄像头模式在线实时分析驾驶员和车外场景的互动',
        },
        subtitle2: {
            title: '精致工艺',
            intro1: '精雕细琢每一个部件',
            intro2: '细腻的金属质感'
        },
        subtitle3: {
            title: '智能识别与分析',
            intro1: '目标识别',
            intro2: '驾驶员视角分析',
        },
    },
    //智能巡检车
    patrolCar: {
        title: '智能巡检车',
        introduction: '智能巡检车在室内外封闭场所，完全自主智能路径规划和导航。通过本地智能视频分析技术，实现异常侵入、打架斗殴等危险情况告警。',
        subtitle1: {
            title: '自主巡逻 智能避障',
            intro1: '自主规划巡逻',
            intro2: '多传感器智能避障',
        },
        subtitle2: {
            title: '本地智能视频分析',
            intro1: '人员异常入侵',
            intro2: '遗落包裹、烟雾、明火等',
        },
        subtitle3: {
            title: '自主充电',
            intro1: '智能电量监测系统',
            intro2: '自主导航回充',
        },
        subtitle4: {
            title: '多场景应用',
            intro1: '公园、厂区、广场',
            intro2: '室内外多场所'
        },
    },
    // 智能模组
    locChip: {
        title: '“芯上学习”智能模组',
        introduction: '全线通自主研发的“芯上学习”智能模组，集成高度泛化、具有在线学习能力的核心算法。',
        subtitle1: {
            title: '本地智能 在线学习',
            intro1: '实时学习与推断分析',
        },
        subtitle2: {
            title: '高效能表现',
            intro1: '高效能SoC架构设计',
            intro2: "万级能耗优化，显著提升续航能力"
        },
        subtitle3: {
            title: '多算法融合',
            intro1: '人脸识别、活体检测',
            intro2: '异常行为分析',
            intro3: "多模数据同步分析"
        },
        subtitle4: {
            title: '多场景应用',
            intro1: '智能物联网、智慧安防、智慧楼宇',
            intro2: '智慧公园、智慧医院、智能诊断',
        },
    },
    TerminalCore: {
        title: '智能终端核心板',
        introduction: '一款可满足多种嵌入式AI产品的高性能自主开发主板，通过精密堆叠及布局，将面积做到极致微小，以满足产品轻薄设计。',
        subtitle1: {
            title: '匠心工艺',
            intro1: '高难度八层两阶HDI设计，匠造微小形体',
            intro2: "先进的化金处理工艺，更安全，更可靠"
        },
        subtitle2: {
            title: '高效能力',
            intro1: '高性能处理器，更低功耗实现更高速运算',
            intro2: "高性能电源集成方案"
        },
        subtitle3: {
            title: '高效速率',
            intro1: 'Wi-Fi/Bluetooth/5G一体，双频双天线',
            intro2: '拥有更优性能，更高速率'
        },
        subtitle4: {
            title: '多种类支持',
            intro1: '支持多种类外设接口',
            intro2: '快速适配定制化底板',
        },
    },
    params: {
        p1: '1080p可见光+红外摄像头',
        p2: '双目摄像头',
        p3: '200万像素宽动态双目（可见光+红外）',
        p4: '识别准确率',
        p5: '内存',
        p6: '识别时间',
        p7: '识别距离',
        p8: '屏幕参数',
        p9: '8寸，分辨率800 X 1280',
        p10: '人脸容量',
        p11: '10000张',
        p12: '操作系统',
        p13: '日志容量',
        p14: '30万条',

        p15: '摄像头',
        p16: '误识率',
        p17: '尺寸（长*宽*高）',
        p18: '精准定位',
        p19: '爬坡角度',
        p20: '续航时间',
        p21: '巡逻速度',
        p22: '材料',
        p23: 'su304/工程塑料',
        p24: '≥3小时'
    }
}



// WEBPACK FOOTER //
// ./src/assets/utils/lang/ru_products.js